import axios from "axios";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  FormControl,
  Input,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Tabs,
  Tab,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import React, { useEffect, useState, Suspense } from "react";
import { Controller, useForm } from "react-hook-form";
import InfiniteScroll from "react-infinite-scroll-component";
import { rem } from "assets/js/common";
import Loading from "components/ui/loading";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  deleteItemButton: {
    background: "none",
    border: "none",
    padding: "5px",
    "min-width": "15px",
    "&:hover": {
      background: "none",
      border: "none",
    },
    "& span": {
      width: "auto",
    },
    "& img": {
      width: "15px",
    },
  },
  faq: {
    "& .search-box-wrap": {
      padding: `${rem(33)} ${rem(30)} ${rem(15)} ${rem(30)}`,
    },
    "& .search-box": {
      "& input": {
        // color: "transparent",
      },
      "& .MuiInputAdornment-root": {
        marginLeft: rem(10),
      },
    },
    "& .MuiTabs-root": {
      // paddingRight: rem(30),
    },
    "& .MuiTabs-flexContainer": {
      "& button:last-child": {
        paddingRight: rem(30),
      }
    }
  },
}));

export default function FaqList(props) {
  const classes = useStyles();
  const [val, setVal] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [fetching, setFetching] = useState(false);
  const handleChangeTab = (event, newValue) => {
    setVal(newValue);
    setSearch("");
    setRows({
      totalPageSize: 0,
      list: [],
    });
    setSchForm({
      ...schForm,
      pg: 1,
      schTxt: "",
      schCatg: newValue == 0 ? "" : newValue == 6 ? "9" : newValue,
    });
  };

  const handleInfiniteScroll = () => {
    if (schForm.pg >= rows.totalPageSize) {
      setInitialized(false);
      return;
    }
    setSchForm({
      ...schForm,
      pg: schForm.pg + 1,
    });
  };

  const onSearch = () => {
    setRows({
      list: [],
    });
    setSchForm({
      ...schForm,
      pg: 1,
      schTxt: search,
    });
  };
  /* Accordion */
  const [expanded, setExpanded] = useState("");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [rows, setRows] = useState({
    totalPageSize: 0,
    list: [],
  });
  const [schForm, setSchForm] = useState({
    pg: 1,
    pgSz: 20,
    schFld: "whle",
    schTxt: "",
    schTp: "1",
    schCatg: "",
    schStrtYmd: "",
    schEndYmd: "",
  });

  const [data, setData] = useState({
    list: [],
  });

  const [initialized, setInitialized] = useState(true);

  useEffect(() => {
    setFetching(true);
    loadData();
  }, [schForm]);

  useEffect(() => {
    if (data) {
      if (schForm.pg == 1) {
        setRows({
          ...data,
        });
      } else {
        setRows({ ...data, list: [...rows.list, ...data.list] });
      }
    }
  }, [data]);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "자주하는 질문", menu: true }));
  }, [init]);

  const loadData = () => {
    return new Promise((resolve) => {
      setFetching(true);
      axios
        .get(`/api/cm/faq`, {
          params: schForm,
        })
        .then((res) => {
          if (res.data.data) {
            setData(res.data.data.faqList);
          }
          resolve(res.data.data);
          setFetching(false);
        })
        .catch((error) => {
          setFetching(false);
        });
    });
  };

  window.appBackKeyHandle = () => {
    history.goBack();
  };

  return (
    <>
      <Loading open={fetching} />
      <main id="main" className={"container " + classes.faq}>
        <Tabs
          value={val}
          onChange={handleChangeTab}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="전체" />
          <Tab label="회원" />
          <Tab label="포인트" />
          <Tab label="혜택" />
          <Tab label="매장이용" />
          <Tab label="APP" />
          <Tab label="기타" />
        </Tabs>
        {/* ST : search-box */}
        <Box className="search-box-wrap">
          <FormControl variant="outlined">
            <OutlinedInput
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              placeholder="궁금하신 내용을 검색해주세요"
              type="search"
              className="search-box"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    type="button"
                    aria-label="search"
                    className="btn-search"
                    edge="end"
                    onClick={onSearch}
                  >
                    <span className="hidden">search</span>
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Box>
        {/* EN : search-box */}
        <InfiniteScroll
          dataLength={rows.list.length}
          next={handleInfiniteScroll}
          hasMore={setInitialized}
          inverse={false}
        >
          <div className="board-list board-list-faq">
            {rows.list.length == 0 && (
              <>
                <div className="nodata mt15">
                  <Box className="illust">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`}
                    />
                  </Box>
                  <p className="color-info">조회된 내역이 없습니다</p>
                </div>
              </>
            )}
            {rows.list.map((item, i) => (
              <Accordion
                key={i}
                expanded={expanded === item.seq}
                onChange={handleChange(item.seq)}
                className="item"
              >
                <AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <p>{item.ttl}</p>
                </AccordionSummary>
                <AccordionDetails>
                  <p
                    className="board-cont"
                    dangerouslySetInnerHTML={{
                      __html: item.cont
                        ? item.cont.split("\n").join("<br />")
                        : "",
                    }}
                  />
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </InfiniteScroll>
      </main>
    </>
  );
}
